import "../css/home.css"
import DivProfile from "../components/divProfile";

import "../css/home.css"
import { useTranslation } from "react-i18next";

const Home = () => {
    const [t] = useTranslation("global");
    return(
        <div className="home" data-aos="zoom-in-down" id="home">
            <h1> {t("Profile.greeting")} <b>{t("Profile.name")}</b> </h1>
            <p data-aos="fade-left">{t("Profile.descriptionName")}</p>
            <DivProfile/>
        </div>
    )
}
export default Home;